import React from "react";

import {
  Form,
  FormElement,
  FormValidator,
  CustomTextControl,
  BaseReactComponent,
  FormSubmitButton,
} from "../../utils/form";
import { Row, Col } from "react-bootstrap";
import { connect } from "react-redux";
import { ComponentHeader, CustomModal, SelectKeywords, Spinner } from "../common";
import { getCommonApi, getKeywordNameApi } from "./Api";
import { postAuthCommonApi, putAuthCommonApi } from "../content/Api";
import { toast } from "react-toastify";
import { withRouter } from "../../utils/hoc/withRouter";

class TargetedContentForm extends BaseReactComponent {
  constructor(props) {
    super(props);

    console.log("TargetedKeywordsForm constructor props:", props);
    const data = props.editData || props?.location?.state?.data || null;
    console.log("TargetedKeywordsForm constructor resolved data:", data);

    let keywordsObj = {};

    if (data) {
      let parsedKeywords = null;
      try {
        parsedKeywords = typeof data?.keywords === 'string' ? JSON.parse(data?.keywords) : data?.keywords;
        if (typeof parsedKeywords === 'string') {
          parsedKeywords = JSON.parse(parsedKeywords);
        }
      } catch (e) {
        console.error("Failed to parse keywords", e);
      }

      if (parsedKeywords && typeof parsedKeywords === 'object' && !Array.isArray(parsedKeywords)) {
        // Load from new object format: {"Beginner":"a,b,c"}
        Object.keys(parsedKeywords).forEach(key => {
          const val = parsedKeywords[key];
          keywordsObj[key] = typeof val === 'string' ? val.split(",").map(item => item.trim()).filter(Boolean) : (Array.isArray(val) ? val : []);
        });
      }

      // Ensure all types from the `types` array exist in the keywords object
      if (Array.isArray(data.types)) {
        data.types.forEach(type => {
          if (type && !keywordsObj[type]) {
            keywordsObj[type] = [];
          }
        });
      }
    }

    this.state = {
      editData: data || "",
      resLoading: false,
      keywords: keywordsObj,
      title: data?.title || "",
      keywordOption: [],
      search: "",
      isAddContent: true,
    };
  }
  async componentDidMount() {
    this.props.getKeywordNameApi(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.search !== prevState.search) {
      this.props.getKeywordNameApi(this);
    }
  }

  keywordsChangeHandler = (info) => {
    this.setState({ search: info })
  }
  onValidSubmit = async () => {
    this.setState({ resLoading: true })
    const { editData, keywords } = this.state;
    if (!keywords || Object.keys(keywords).length === 0) {
      toast.error("Fields can not be empty.");
      this.setState({ resLoading: false });
    } else {
      // Map the array values in our state to comma-separated strings
      const submitKeywords = {};
      Object.keys(keywords).forEach(key => {
        submitKeywords[key] = keywords[key].join(",");
      });

      let eventData = {
        "data": {
          "keywords": JSON.stringify(submitKeywords)
        }
      };

      if (this.state.editData) {
        const response = await putAuthCommonApi(`targetedContentFilters/${this.state.editData?.uuid}`, eventData);
        if (response.status === 200) {
          this.setState({ resLoading: false });
          // Refresh parent list and close modal
          const ctx = this.props.this || this.props.ctx;
          if (ctx) {
            ctx.props.getAllTagretedContentFiltersKeywordApi(ctx);
          }
          this.props.onHide();
        } else {
          this.setState({ resLoading: false })
        }
      }
    }
  };

  render() {
    const { resLoading, keywords } = this.state;
    const keywordKeys = Object.keys(keywords || {});

    return (
      <CustomModal
        show={this.props.show}
        onHide={this.props.onHide}
        title={this.state.editData ? "Edit Targeted Keywords" : "Add Targeted Keywords"}
        modalClass={"change-password"}
      >
        <Form onValidSubmit={this.onValidSubmit}>
          <Row>
            <Col sm={12} className="mb-3">
              <FormElement
                valueLink={this.linkState(this, "title")}
                label="Title"
                required
                control={{
                  type: CustomTextControl,
                  settings: {
                    placeholder: "Title",
                    disabled: true,
                  },
                }}
              />
            </Col>
            <Col sm={12} className="mt-2 mb-3">
              <h5 className="inter-semibold">Keywords</h5>
              <hr />
            </Col>
            {
              keywordKeys.length > 0 ? (
                keywordKeys.map((key, index) => (
                  <Col md={6} key={index} className="mb-5">
                    <SelectKeywords
                      required={false}
                      label={key || `Keyword ${index + 1}`}
                      placeholder={'Enter Keywords'}
                      onchangeHandler={(data) => this.keywordsChangeHandler(data)}
                      selectedKeyWords={keywords[key] || []}
                      options={this.state.keywordOption}
                      getKeys={(data) => {
                        const newKeywords = { ...keywords };
                        newKeywords[key] = data;
                        this.setState({ keywords: newKeywords });
                      }}
                    />

                  </Col>
                ))
              ) : (
                <Row>
                  <Col md={12}>
                    <p>No Fields to edit yet.</p>
                  </Col>
                </Row>
              )
            }
          </Row>
          <div className="submit-wrapper" style={{ justifyContent: "center" }}>
            <FormSubmitButton customClass={"primary-btn"}>
              {resLoading ? <span className="d-flex align-items-center gap-12"> <Spinner /> Saving...</span> : "Save"}
            </FormSubmitButton>
          </div>
        </Form>
      </CustomModal>
    );
  }
}

export default connect(null, { getKeywordNameApi })(withRouter(TargetedContentForm));
